import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/content";

export const Ribbon = () => (
  <div
    className="border-y border-white/5 bg-[#0a0a0a] py-8"
    data-testid="marquee-ribbon"
  >
    <Marquee speed={26} gradient={false} autoFill>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-8">
          <span className="font-serif text-4xl italic tracking-tight text-zinc-800 sm:text-5xl">
            {item}
          </span>
          <span className="text-gold/40 text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
